/**
 * 待播放的当前帧数据
 *  ws 的链接问题：
 *  1. 每个车启用一个ws链接；并返回该车的可用数据的时间段，渲染成可选项；
 *  2. 根据不同的时间段，发起ws message，获取对应的数据；
 */
import { defineStore } from 'pinia'
import { ref } from "vue";
import { useStore } from '@/store';
import { useRoute } from 'vue-router';
export const useMetaDataStore = defineStore('metaDataStore', () => {
    const store = useStore();
    const route = useRoute();
    let vehicleInfo_data = ref(null);
    let playlist_data = ref(null);
 

    function setVehicleInfo(data: any) {
        vehicleInfo_data.value = data
        console.log('VehicleInfo', data);
        // if (vehicleInfo) {
        //     store.commit('wsModule/setWsstate', 300); //todo
        //   }
    }

    function setPlaylist(data: any) {
        playlist_data.value = data;
        if(data?.length>0){
            store.commit('setLoadingText', {text:'已经加载该车可播放列表,请选择时段'});
            if(route.query.ts){
                store.commit('setLoadingText',{text:'未找到要播放的时间段数据'});
            }
        }
        else{
            store.commit('setLoadingText', {text:'该车没有可播放的数据'});
        }        
    }  

    return {
        setVehicleInfo, setPlaylist, vehicleInfo_data, playlist_data,
    }
})